import { DateTimePicker, DropDownList } from "@repo/ui";

import type { LayerFilterProps } from "../hooks/useUpdateLayerFilter";

import { DATE_RANGE_OPTIONS } from "../layers/dateRange";

interface DateRangeFilterProps extends LayerFilterProps {
	dateOnly?: boolean;
}

export function DateRangeFilter({ layer, updateFilter, dateOnly }: DateRangeFilterProps) {
	return (
		<>
			<DropDownList
				id="dateRange"
				label="Date Range"
				placeholder="Custom"
				value={layer.dateRange}
				changeHandler={(value: string) => updateFilter(value || undefined, "dateRange")}
				values={DATE_RANGE_OPTIONS}
				valueProp="id"
				textProp="value"
				fullLength
			/>
			{!layer.dateRange && (
				<>
					<DateTimePicker
						id="startDateTime"
						label="Start Date"
						value={layer.startDateTime}
						changeHandler={updateFilter}
						dateOnly={dateOnly}
					/>
					<DateTimePicker
						id="endDateTime"
						label="End Date"
						value={layer.endDateTime}
						changeHandler={updateFilter}
						dateOnly={dateOnly}
					/>
				</>
			)}
		</>
	);
}
